import { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "common-components";
import { Checkbox } from "antd";
import { UiModalTitle, StyledDeprecateQuestion } from "./DeprecateQuestionModal.style";

/** 可下架的產品，對應後端 availabilities；選萬通會一併下架紙本、速測、合輯與 AI 出題 */
const AVAILABILITY_OPTIONS = [
	{ label: "紙本", value: "paper" },
	{ label: "速測", value: "quick" },
	{ label: "萬通", value: "oneClass" },
];

export const DeprecateQuestionModal = ({ isLoading, onOk, onCancel }) => {
	const [availabilities, setAvailabilities] = useState([]);

	return (
		<Modal
			title={<UiModalTitle>請選擇下架產品</UiModalTitle>}
			visible={true}
			width="480px"
			onCancel={onCancel}
			footer={
				<>
					<Button variant="white" full={false} onClick={onCancel}>
						取消
					</Button>
					<Button
						variant="orange"
						full={false}
						loading={isLoading}
						disabled={availabilities.length === 0}
						onClick={() => onOk(availabilities)}>
						確定
					</Button>
				</>
			}>
			<StyledDeprecateQuestion>
				<Checkbox.Group options={AVAILABILITY_OPTIONS} value={availabilities} onChange={setAvailabilities} />
			</StyledDeprecateQuestion>
		</Modal>
	);
};

DeprecateQuestionModal.propTypes = {
	isLoading: PropTypes.bool,
	onOk: PropTypes.func,
	onCancel: PropTypes.func,
};
